// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueSweetAlert from 'vue-sweetalert'
import Vuelidate from 'vuelidate'
import vuelidateErrorExtractor from 'vuelidate-error-extractor'
import MetronicInputTemplate from '@utils/metronic-input-template'
import Notifications from 'vue-notification'
import VueTheMask from 'vue-the-mask'
import VueEvents from 'vue-events'
import eventBus from './plugins/event-bus'
import Select2 from 'v-select2-component'
import Multiselect from 'vue-multiselect'
import VueTour from 'vue-tour'
import VuePageTransition from 'vue-page-transition'
import VueSelect from 'vue-cool-select'
import VueCurrencyInput from 'vue-currency-input'

import TheContainer from './the-container'
import router from './router'
import store from './store'
import Scroll from '@/directives/scroll'
import DateRangePicker from 'vue2-daterange-picker'
import Clipboard from 'v-clipboard'
import JsonExcel from 'vue-json-excel'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import appsignal from './utils/signal'
import { errorHandler } from '@appsignal/vue'

Vue.config.errorHandler = errorHandler(appsignal, Vue)

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.config.productionTip = false

window.$ = window.jQuery = require('jquery')
require('bootstrap')

Vue.use(eventBus)
Vue.use(VueTheMask)
Vue.use(Notifications)
Vue.use(VueSweetAlert)
Vue.use(Vuelidate)
Vue.use(VueEvents)
Vue.use(VueTour)
Vue.use(VuePageTransition)
Vue.use(require('vue-moment'))
Vue.use(vuelidateErrorExtractor, {
  template: MetronicInputTemplate,
  messages: {
    required: '{attribute} não pode ser vazio',
    email: '{attribute} em formato inválido',
    minLength: '{attribute} deve conter no mínimo {min} caractéres',
    sameAsPassword: '{attribute} deve ser igual a senha'
  }
})

Vue.use(VueSelect, {
  theme: 'bootstrap'
})

Vue.use(Clipboard)

Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: 'BRL',
    currencyDisplay: 'symbol',
    precision: 2,
    distractionFree: false,
    autoDecimalMode: true
  },
  componentName: 'Money' // Replace old v-money component
})

Vue.component('Select2', Select2)
require('vue-tour/dist/vue-tour.css')

Vue.component('DateRangePicker', DateRangePicker)
require('vue2-daterange-picker/dist/vue2-daterange-picker.css')

Vue.component('Multiselect', Multiselect)
require('vue-multiselect/dist/vue-multiselect.min.css')
/* eslint-disable no-new */

Vue.component('DownloadExcel', JsonExcel)

Vue.directive('scroll', Scroll)

new Vue({
  el: '#app',
  router,
  store,
  template: '<TheContainer/>',
  components: { TheContainer }
})



// WEBPACK FOOTER //
// ./src/main.js